import {TypePj} from './type-pj.model';

export let matriceNavigationEtapesAvecPieceMap = new Map<number, TypePj>([
    [9, TypePj.LIEN_DETENU],
    [10, TypePj.PHOTO],
    [11, TypePj.PIECE_IDENTITE],
    [12, TypePj.JUSTIFICATIF_DOMICILE],
    [13, TypePj.JUSTIFICATIF_MINEUR],
    [14, TypePj.COMPLEMENTAIRE1],
    [15, TypePj.COMPLEMENTAIRE2],
    [16, TypePj.COMPLEMENTAIRE3],
]);
